/**
 * Tiny build-version stamp shown to admins.
 * Renders nothing for non-admin users.
 */
import { useState } from 'react';
import { BUILD_INFO } from '@/buildInfo';
import { useAuth } from '@/context/AuthContext';

const formatBuiltAt = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  // YYYY-MM-DD HH:mm UTC
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
};

const BuildVersionStamp = () => {
  const { user } = useAuth();
  const [expanded, setExpanded] = useState(false);

  if (!user) return null;
  const role = user.role;
  if (role !== 'admin' && role !== 'super_admin') return null;

  const { sha, branch, builtAt } = BUILD_INFO || {};

  return (
    <button
      onClick={() => setExpanded((v) => !v)}
      data-testid="build-version-stamp"
      title="Build info — click to expand"
      className="block w-full text-left px-3 py-1.5 text-[10px] text-gray-400 hover:text-gray-600 font-mono leading-tight transition-colors border-t border-gray-100 mt-2"
    >
      {expanded ? (
        <span>
          v.{sha} · {branch}<br />
          {formatBuiltAt(builtAt)}
        </span>
      ) : (
        <span>v.{sha}</span>
      )}
    </button>
  );
};

export default BuildVersionStamp;
